module.exports = __webpack_public_path__ + "img/altri-report.170cfbd2.svg";